import { c as _c } from "react/compiler-runtime";
import type { Entity } from '@onefootprint/request-types/dashboard';
import type useEntityVault from '@/entities/hooks/use-entity-vault';
import type { EntityVault } from '@/types/vault';
import CardGrid from '../card-grid';
import { CardError, CardSkeleton } from '../card-title';
import Fieldset from './components/fieldset';
import useFieldsets from './hooks/use-fieldsets';
type OnboardingVaultDataProps = {
  entity: Entity;
  vault: ReturnType<typeof useEntityVault>;
  isLoading?: boolean;
  error?: unknown;
};
const OnboardingVaultData = t0 => {
  const $ = _c(7);
  const {
    entity,
    vault,
    isLoading,
    error
  } = t0;
  const {
    data: vaultData
  } = vault;
  const fieldsets = useFieldsets(entity, vaultData?.vault as EntityVault);
  if (isLoading || error) {
    let t1;
    if ($[0] !== error) {
      t1 = error ? <CardError error={error} /> : <CardSkeleton cards={3} rows={4} />;
      $[0] = error;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== fieldsets) {
    t1 = Object.entries(fieldsets);
    $[2] = fieldsets;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1 || $[5] !== vaultData) {
    t2 = <CardGrid>{t1.map(t3 => {
        const [key, fieldset] = t3;
        return <Fieldset key={key} fields={fieldset.fields} title={fieldset.title} vaultData={vaultData} />;
      })}</CardGrid>;
    $[4] = t1;
    $[5] = vaultData;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default OnboardingVaultData;